import { createFileRoute } from "@tanstack/react-router";
import { AboutPage, aboutHeadEn } from "@/pages/AboutPage";

export const Route = createFileRoute("/en/about")({
  head: aboutHeadEn,
  component: AboutPage,
});
